function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M148.222,70.616a52.755,52.755,0,1,0,52.757,52.756,52.754,52.754,0,0,0-52.757-52.756m0,76.676a23.922,23.922,0,1,1,23.924-23.921,23.921,23.921,0,0,1-23.924,23.921",
  transform: "translate(-25.216 -17.862)",
  fill: "#db8d27"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M56.175,132.664H37.215V18.8a16.083,16.083,0,0,0-32.165,0V144.9a16.064,16.064,0,0,0,13.175,15.789,14.117,14.117,0,0,0,2.872.293H56.175a14.159,14.159,0,1,0,0-28.318",
  transform: "translate(-5.05 -2.72)",
  fill: "#db8d27"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M334.724,162.021A52.753,52.753,0,1,0,262.371,162c-.061.056-.131.106-.192.162a50.174,50.174,0,0,0,9.348,6.76,52.388,52.388,0,0,0,27.033,7.518A23.921,23.921,0,1,1,280.046,215.5c-.051-.071-.652-.971-.845-1.249L254.059,228.4a33.746,33.746,0,0,0,2.351,3.665,52.73,52.73,0,1,0,78.314-70.048m-60.083-38.338a23.922,23.922,0,1,1,23.92,23.919,23.922,23.922,0,0,1-23.92-23.919",
  transform: "translate(-58.743 -17.917)",
  fill: "#31a3b4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M487.227,70.614h0a14.407,14.407,0,0,0-12.28,6.891,52.757,52.757,0,1,0,0,91.723,14.406,14.406,0,0,0,26.7-7.518V85.033a14.42,14.42,0,0,0-14.418-14.419M448.89,147.291a23.922,23.922,0,1,1,23.924-23.922,23.921,23.921,0,0,1-23.924,23.922",
  transform: "translate(-92.264 -17.86)",
  fill: "#db8d27"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M283.5,261.4a14.455,14.455,0,1,1-14.453-14.455A14.454,14.454,0,0,1,283.5,261.4",
  transform: "translate(-60.702 -57.188)",
  fill: "#db8d27"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M541.434,80.593a9.98,9.98,0,1,1,9.98,9.98,9.98,9.98,0,0,1-9.98-9.98m17.695,0a7.717,7.717,0,1,0-7.715,7.887,7.848,7.848,0,0,0,7.715-7.887m-10,.966V85.5a.91.91,0,0,1-1.819,0V75.6c0-.41.2-.576.631-.576h3.641c2.755,0,4.166.8,4.166,3.281a2.9,2.9,0,0,1-2.847,3.17l2.452,3.746a1.59,1.59,0,0,1,.283.693c0,.3-.551.465-1.027.465a1.118,1.118,0,0,1-1.1-.607l-2.614-4.217Zm2.093-1.653c1.406,0,2.7-.111,2.7-1.734,0-1.38-1.345-1.491-2.538-1.491h-2.255V79.9Z",
  transform: "translate(-124.674 -17.861)",
  fill: "#db8d27"
});

var SvgLogaLogo2 = function SvgLogaLogo2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_Loga-1",
    width: 352.72,
    height: 235.231,
    viewBox: "0 0 436.72 235.231",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogaLogo2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loga_logo_2.53f1c4c9.svg";
export { ForwardRef as ReactComponent };